import {inject, Injectable, ProviderToken} from "@angular/core";

export interface DeferredInjectable {
    inject(): void;
}

function isDeferredInjectable(value: unknown): value is DeferredInjectable {
    return typeof value === "object" &&
        value !== null &&
        typeof (value as any).inject === "function";
}

/**
 * This service provides deferred injection of services/models
 */
@Injectable({providedIn: "root"})
export class DeferredInjectionService {
    private injectables: DeferredInjectable[] = [];
    private injected: boolean = false;

    public inject<T>(token: ProviderToken<T>): T {
        if (this.injected) {
            throw new Error("Cannot register tokens after injectDeferred() has been called");
        }
        const injectable: T = inject(token);
        if (!isDeferredInjectable(injectable)) {
            throw new Error(`Cannot register ${token.toString()}. It does not implement DeferredInjectable`);
        }
        this.injectables.push(injectable);
        return injectable;
    }

    public injectAll(...tokens: ProviderToken<any>[]): void {
        tokens.forEach((token: ProviderToken<any>) => this.inject(token));
    }

    public injectDeferred(): void {
        this.injected = true;
        this.injectables.forEach((injectable: DeferredInjectable) => {
            injectable.inject();
        });
    }
}
